const toRad = (d) => (d * Math.PI) / 180;

export const distanceKm = (a, b) => {
  const dLat = toRad(b.lat - a.lat), dLng = toRad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * 6371 * Math.asin(Math.sqrt(h));
};

/** Nearest country by centroid; `inside` ≈ within the country's equivalent radius (computed locally, nothing sent anywhere). */
export function nearestCountry(countries, pos) {
  let best = null;
  for (const c of countries) {
    if (!c.position) continue;
    const km = distanceKm(pos, c.position);
    if (!best || km < best.km) best = { country: c, km };
  }
  if (!best) return null;
  const radius = Math.sqrt((best.country.area_km2 || 10000) / Math.PI) * 1.4 + 60;
  return { ...best, km: Math.round(best.km), inside: best.km <= radius };
}

/** One-shot GPS read, only on explicit user action. Rejects with "unsupported" | "denied" | "unavailable". */
export const locate = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) return reject(new Error("unsupported"));
  navigator.geolocation.getCurrentPosition(
    (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude }),
    (e) => reject(new Error(e.code === 1 ? "denied" : "unavailable")),
    { enableHighAccuracy: false, timeout: 12000, maximumAge: 300000 },
  );
});
